import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/auth'
import { useSeo } from '@/lib/useSeo'
import { AuthLayout, inputBase, labelBase, primaryButton } from '@/components/public/AuthLayout'

export function ResetPassword() {
  useSeo({ title: 'Reset password', description: 'Set a new password for your VICE account.' })
  const { updatePassword } = useAuth()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    if (password.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match.')
      return
    }
    setSubmitting(true)
    const { error: err } = await updatePassword(password)
    setSubmitting(false)
    if (err) {
      setError(err.message)
      return
    }
    navigate('/dashboard', { replace: true })
  }

  return (
    <AuthLayout title="Set a new password" subtitle="Minimum 8 characters.">
      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label htmlFor="password" className={labelBase}>
            New password
          </label>
          <input
            id="password"
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputBase}
          />
        </div>
        <div>
          <label htmlFor="confirm" className={labelBase}>
            Confirm new password
          </label>
          <input
            id="confirm"
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className={inputBase}
          />
        </div>
        {error && <p role="alert" className="text-sm text-error">{error}</p>}
        <button type="submit" disabled={submitting} className={primaryButton}>
          {submitting ? 'Updating…' : 'Update password'}
        </button>
        <p className="text-center text-sm text-neutral-600">
          <Link to="/signin" className="text-secondary font-semibold hover:text-primary">
            Cancel
          </Link>
        </p>
      </form>
    </AuthLayout>
  )
}
